import Button from '@mui/material/Button'
import React from 'react'
import FilterForm from './FilterForm'
import { useAdvancedSearchStore } from '../hooks/useAdvancedSearch'
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

function AdvancedSearch({ onSubmit, onClear, resultsCount }) {
    const showAdvanceFilter = useAdvancedSearchStore(s => s.showAdvanceFilter)
    const setShowAdvanceFilter = useAdvancedSearchStore(s => s.setShowAdvanceFilter)
    const clearAll = useAdvancedSearchStore(s => s.clearAll)

    const onClose = () => {
        setShowAdvanceFilter(false)
    }

    React.useEffect(() => {
        clearAll?.()
    }, [])

    if (!showAdvanceFilter) return null

    return (
        <div className='fixed top-0 left-0 right-0 bottom-0 z-[1301] bg-[#F7F7F7] overflow-auto'>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                }}
            >
                <CloseIcon
                    style={{
                        height: 30,
                        width: 30
                    }}
                />
            </IconButton>
            <FilterForm onSubmit={onSubmit} onClear={onClear} resultsCount={resultsCount} />
        </div>
    )
}

export default AdvancedSearch